





























import { Component, Prop } from 'vue-property-decorator';
import { AgencyStatus } from 'admiral-core';
import Multiselect from 'vue-multiselect';
import Avatar from '@/components/common/Avatar.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { CheckIcon } from 'vue-feather-icons';
import { FormatMixin } from '@/mixins/FormatMixin';
import { Util } from '@/utils/Util';

@Component({
  components: { Multiselect, Avatar, CheckIcon },
})
export default class AgencyStatusSelect extends mixins(BaseMixin, FormatMixin) {
  @Prop()
  status!: AgencyStatus;

  updateStatus(status: AgencyStatus) {
    this.$emit('update-status', status);
  }

  get options() {
    return [
      AgencyStatus.INACTIVE,
      AgencyStatus.DEMO,
      AgencyStatus.MONTHLY,
      AgencyStatus.YEARLY,
      AgencyStatus.PERPETUAL,
      AgencyStatus.CANCELLED,
    ];
  }
  label(agencyStatus: AgencyStatus) {
    return Util.formatAgencyStatus(agencyStatus);
  }

  isSelected(agencyStatus: AgencyStatus) {
    return agencyStatus === this.status;
  }
}
